/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';
import styled from '@emotion/styled';
import { HEADER_HEIGHT } from '../../common/constants';
export var PageActions = function PageActions() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};
var Wrapper = styled.div({
  position: 'fixed',
  top: "".concat(HEADER_HEIGHT, "px"),
  right: 0
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "359",
    height: "88",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageActionsA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PageActionsB)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "87",
    y: "28",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M91 32h24v24H91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M95.02 51.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21-.78 3.81Zm5.921-2.62-2.12-2.12 8.485-8.49h.002l2.121 2.121-8.489 8.49.001-.001Zm9.903-9.903-2.12-2.122a2 2 0 0 0-1.416-.585c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 0 0 0-2.828h.001Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "119",
    y: "28",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M123 32h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M127.998 43.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51Zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-4.142-4.037-7.513-9-7.513s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.03.164.033a.516.516 0 0 0 .475-.716Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    d: "M139 41h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2ZM134 44h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "151",
    y: "28",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M155 32h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    d: "m167 48.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L167 37.687l-1.972 4.189-4.524.689 3.276 3.345-.762 4.655L167 48.373Zm0 2.283-3.016 1.662a2.001 2.001 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a1.994 1.994 0 0 1 .141-2.93c.282-.237.624-.392.988-.447l3.47-.528 1.518-3.224A2.004 2.004 0 0 1 167 35.687a2 2 0 0 1 1.809 1.147l1.519 3.224 3.47.528a2.001 2.001 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a1.999 1.999 0 0 1-2.94 2.075L167 50.656Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "183",
    y: "28",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M187 32h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M199 50c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6H199Zm.001-14C193.48 36 189 40.841 189 44c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    fillRule: "evenodd",
    d: "M198.977 45.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2Zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "60",
    height: "32",
    x: "221",
    y: "28",
    fill: "#091E42",
    fillOpacity: ".08",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "44",
    height: "6",
    x: "229",
    y: "41",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "287",
    y: "28",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M291 32h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C7D0",
    d: "M296 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM303 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM310 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PageActionsA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87 28h232v32H87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PageActionsB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87 28h128v32H87z"
  }))));
};